import { useTranslation } from "next-i18next";
import { useState } from "react"
import styles from '../styles/outrun_possibilities.module.scss';

const possibilities = new Array(9).fill('');

export default function OutrunPossibilities() {
	const { t } = useTranslation('outrun');

  const [currentPossibility, setCurrentPossibility] = useState(0);

  const changeCurrentPossibility = (key) => () => {
    setCurrentPossibility(key);
  };

  return (
    <section className={styles.possibilities}>
      <h2>{t('possibilities.title')}</h2>
      <div className={styles.possibilities__content}>
        <div className={styles.triggers}>
            {
              possibilities.map((_, key) => <button key={key} onClick={changeCurrentPossibility(key)} className={currentPossibility === key ? styles.active : ''}>
                {t(`possibilities.trigger${key + 1}`)}
              </button>)
            }
        </div>
        <div className={styles.possibility__content}>
          <h3>{t(`possibilities.subtitle${currentPossibility + 1}`)}</h3>
          <p dangerouslySetInnerHTML={{__html: t(`possibilities.description${currentPossibility + 1}`, { interpolation: { escapeValue: false }}) }} />
        </div>
      </div>
    </section>
  )
};
